<template>
  <b-button block @click="handleLogin" class="provider">
    <div class="d-flex align-items-center justify-content-center">
      <Icon name="facebookProvider" :width="20"/>
      <span class="ml-2">{{$t('forms.login_form.continue_facebook')}}</span>
    </div>
  </b-button>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {AuthProviders} from '@/domain/auth/constants/authProviders'

export default {
  name: 'FacebookLoginButton',

  data() {
    return {
      loading: false
    }
  },

  async mounted() {
    // Preload SDK for faster login
    const provider = this.authProviderFactory.getProvider(AuthProviders.FACEBOOK)
    if (provider) {
      await provider.loadSDK()
    }
  },

  computed: {
    ...mapGetters('auth', ['authProviderFactory'])
  },

  methods: {
    ...mapActions('auth', ['authenticate']),

    async handleLogin() {
      this.loading = true

      try {
        const provider = this.authProviderFactory.getProvider(AuthProviders.FACEBOOK)

        // Get token from SDK via provider
        const token = await provider.startLogin()

        // Authenticate with backend
        await this.authenticate({
          method: AuthProviders.FACEBOOK,
          credentials: {
            token,
            allowRegister: true
          },
          remember: true
        })

        this.$emit('success')
      } catch (error) {
        console.error('Facebook login error:', error)
        this.$emit('error', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
a {
  display: inline-block;
  transition: opacity 0.2s;
}

a:hover:not(.disabled) {
  opacity: 0.8;
}

a.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

img {
  display: block;
}
</style>
